import type { JSX } from 'react';

import clsx from 'clsx';

import { textColorClasses } from '@/components/classes/textColorClasses';
import { testIds } from '@/components/constants/testIds';
import type { Adaptive } from '@/components/types/Adaptive';
import type { Color } from '@/components/types/Color';
import type { Size } from '@/components/types/Size';
import { componentsConfig } from '@/config/componentsConfig';
import appIcons from '@/constants/appIcons';

import Icon from '../Icon';

type SpinnerProps = {
    size?: Adaptive<Size>;
    color?: Color;
    className?: string;
    testId?: string;
};

export default function Spinner({
    size = componentsConfig.spinner.size,
    color = componentsConfig.spinner.color,
    testId = testIds.spinner.base,
    className,
}: SpinnerProps): JSX.Element {
    // ----------------------------------------------------------------------------------------------------
    // MARK: Main Component UI
    // ----------------------------------------------------------------------------------------------------
    return (
        <div data-testid={testId} className={clsx(className)}>
            <div className="flex items-center justify-center align-middle">
                <Icon
                    icon={appIcons.outline.loading}
                    className={clsx(textColorClasses[color], 'animate-spin')}
                    testId={testIds.spinner.icon}
                    size={size}
                />
            </div>
        </div>
    );
}
